import React from "react";
import Dashboard from "../components/Dashboard";
import { Box, Button, Typography, Paper, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const Usage = () => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Box sx={{ 
            width: '100%', 
            height: '100%',
            overflow: 'auto',
            pb: 4
        }}>
            <h1 className="page-title">Usage</h1>
            <Dashboard />
            
            {/* Upgrade Banner */}
            <Paper 
                sx={{ 
                    p: 2, 
                    mt: 4,
                    maxWidth: '1000px',
                    mx: 'auto',
                    background: 'linear-gradient(90deg, #BFDBFE 0%, #93C5FD 100%)',
                    color: '#002966',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    opacity: 0.9
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <WorkspacePremiumIcon sx={{ fontSize: 24, opacity: 0.9, color: '#002966' }} />
                    <Typography variant="body1" sx={{ opacity: 0.9 }}>
                       Manage or upgrade your plan
                    </Typography>
                </Box>
                <Button 
                    variant="contained" 
                    color="primary"
                    onClick={() => navigate('/plan')}
                    size="small"
                    sx={{ 
                        bgcolor: '#002966',
                        '&:hover': {
                            bgcolor: '#001B3D'
                        }
                    }}
                >
                    View Plan
                </Button>
            </Paper>
        </Box>
    );
};

export default Usage;
